'use client';

import React, {useState, useEffect} from 'react';
import {HtmlSanitizerBuilder, type SafeHtml} from 'safevalues';
import {getTrustedTooltipItem} from '../TroubleShooting/utils';

export default function SanitizedHTMLComponent({
  contentString,
  locale,
}: {
  contentString: string;
  locale: string;
}) {
  const [content, setContent] = useState<SafeHtml>();
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (contentString !== undefined) {
      const TrustedData = async () => {
        const trustedHtml = await getTrustedTooltipItem(contentString, locale);
        /**
         * Explicit sanitization is required for SSG.
         * It doesn't allow directly trusted HTML.
         * So, I've performed explicit sanitization again.
         */
        const sanitizer = new HtmlSanitizerBuilder()
          .allowCustomElement('article-tool-tip')
          .allowCustomElement('article-tool-tip-info')
          .allowCustomElement('article-alert-warning')
          .allowCustomElement('article-alert-red')
          .build();
        const trustedData = sanitizer.sanitize(trustedHtml?.toString());
        setContent(trustedData);
      };
      TrustedData();
    }
  }, [contentString]);
  return (
    <>
      {content && (
        <div
          // biome-ignore lint/security/noDangerouslySetInnerHtml: Intentionally rendering the trusted HTML after sanitization.
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        />
      )}
    </>
  );
}
